import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  EditPunchSessionExitInput,
  PunchSessionAdjustment,
} from '@models/punchSessionAdjustment.model';
import { punchSessionAdjustmentService } from '@services/punchSessionAdjustment';
import { PUNCH_CLOCKS_BY_USER_KEY } from '@hooks/api/punchClock/usePunchClocksByUser';
import { PUNCH_SESSION_ADJUSTMENTS_BY_USER_KEY } from './usePunchSessionAdjustmentsByUser';

export const useEditPunchSessionExit = () => {
  const queryClient = useQueryClient();
  return useMutation<PunchSessionAdjustment, Error, EditPunchSessionExitInput>({
    mutationFn: (input) => punchSessionAdjustmentService.editSessionExit(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PUNCH_SESSION_ADJUSTMENTS_BY_USER_KEY });
      // Punch data itself is unchanged, but refetching keeps the drawer's derived
      // totals aligned with the freshly-written adjustment.
      queryClient.invalidateQueries({ queryKey: PUNCH_CLOCKS_BY_USER_KEY });
    },
  });
};

export default useEditPunchSessionExit;
